<app-header></app-header>
<mat-sidenav-container 
    class="flex-fill flex-row sidenav-container"
    hasBackdrop="false">
    <mat-sidenav 
        mode="side" 
        opened
        class="sidenav backcolor-primary"
        [style.width]="sidenavWidth()" >
        <app-navigation 
            class="flex-force flex-fill flex-row">
        </app-navigation>
    </mat-sidenav>
    <mat-sidenav-content 
        class="flex-force flex-fill flex-row sidenav-content" 
        [style.margin-left]="sidenavWidth()" >
        <!-- Your main content goes here -->
        <router-outlet class="backcolor-primary-contrast" ></router-outlet>
    </mat-sidenav-content>
    <mat-sidenav 
        position="end" 
        mode="over" 
        fixedInViewport="true" 
        fixedTopGap="120" 
        [opened]="appStateService.sidepanelInfoExpanded() || appStateService.sidepanelHistoryExpanded()"
        [ngClass]="appStateService.sidepanelInfoExpanded() ? 'sidepanel' : (appStateService.sidepanelHistoryExpanded() ? 'sidepanel-max' : 'sidepanel')">
        <app-sidepanel class="flex-force flex-fill flex-col"></app-sidepanel>
    </mat-sidenav>
</mat-sidenav-container>


